/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_Next_HintInputs */

const vi_einvoice_publish_next_hint = /** @type {(inputs: Einvoice_Publish_Next_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất bản sẽ yêu cầu xác nhận trước khi phát hành chính thức.`)
};

/**

* @param {Einvoice_Publish_Next_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_next_hint = /** @type {((inputs?: Einvoice_Publish_Next_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_Next_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_next_hint(inputs)
});